import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
interface AppContextType {
  orderNumber: string | null;
  setOrderNumber: (code: string | null) => void;
  scannerCode: string | null;
  setScannerCode: (code: string | null) => void;
}

// Create a combined context
const AppContext = createContext<AppContextType>({
  orderNumber: null,
  setOrderNumber: () => {},
  scannerCode: null,
  setScannerCode: () => {},
});

// Define props for the provider
interface AppProviderProps {
  children: ReactNode;
}

// Create the combined provider component
export const AppProvider = ({ children }: AppProviderProps) => {
  const [orderNumber, setOrderNumber] = useState<string | null>(null);
  const [scannerCode, setScannerCode] = useState<string | null>(null);

  const contextValue = useMemo(
    () => ({
      orderNumber,
      setOrderNumber,
      scannerCode,
      setScannerCode,
    }),
    [orderNumber, scannerCode]
  );

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};

// Hook to use the combined context
export const useAppContext = (): AppContextType => {
  return useContext(AppContext);
};
